import React, { useState } from "react";
import axios from "axios";
import config from "../../config";
import "./RestaurantPrice.css";

const RestaurantPrice = ({
  prevStep,
  nextStep,
  restaurantData,
  updateRestaurantData,
  user, // ensure you pass the user object to get userID
}) => {
  const [minOrder, setMinOrder] = useState(restaurantData.min_order || "");
  const [deliveryFee, setDeliveryFee] = useState(
    restaurantData.delivery_fee || ""
  );
  const [menuFile, setMenuFile] = useState(restaurantData.menuFile || null);

  const handleMenuFileChange = (e) => {
    const file = e.target.files[0];
    setMenuFile(file);
    updateRestaurantData({ menuFile: file });
  };

  const saveAndNext = async () => {
    // Update pricing info in the parent state
    updateRestaurantData({ min_order: minOrder, delivery_fee: deliveryFee });

    // 1) If restaurantID is not created yet, create the restaurant record
    if (!restaurantData.restaurantID) {
      try {
        const dataToSend = {
          ...restaurantData,
          min_order: minOrder,
          delivery_fee: deliveryFee,
          userID: user.userID, // ensure user object is available
        };
        const createResp = await axios.post(
          `${config.apiBaseUrl}/api/restaurants/add`,
          dataToSend,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        updateRestaurantData({ restaurantID: createResp.data.id });
      } catch (error) {
        console.error("Failed to create restaurant", error);
        alert("Failed to create restaurant");
        return;
      }
    }

    // 2) If a menu file was selected, upload it now using the created restaurantID
    if (menuFile) {
      try {
        const formData = new FormData();
        formData.append("file", menuFile);
        formData.append("restaurantID", restaurantData.restaurantID);
        const uploadResp = await axios.post(
          `${config.apiBaseUrl}/api/restaurants/upload-menu`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        // Save the returned menu URL in the restaurant data
        console.log(uploadResp.data)
        updateRestaurantData({ menu: uploadResp.data.menuUrl });
      } catch (error) {
        console.error("Failed to upload menu", error);
        alert("Failed to upload menu");
        return;
      }
    }

    // 3) Proceed to the next step
    nextStep();
  };

  return (
    <div className="restaurant-price">
      <h2>Restaurant Pricing</h2>
      <label>Minimum Order:</label>
      <input
        type="number"
        name="min_order"
        value={minOrder}
        onChange={(e) => setMinOrder(e.target.value)}
      />
      <label>Delivery Fee:</label>
      <input
        type="number"
        name="delivery_fee"
        value={deliveryFee}
        onChange={(e) => setDeliveryFee(e.target.value)}
      />

      {/* New Menu Upload Section */}
      <label>Upload Menu (PDF, DOC, Images):</label>
      <input
        type="file"
        accept=".pdf,.doc,.docx,image/*"
        onChange={handleMenuFileChange}
      />

      <div className="restaurant-navigation-buttons">
        <button onClick={prevStep} className="prev-btn">
          Back
        </button>
        <button onClick={saveAndNext} className="next-btn">
          Next
        </button>
      </div>
    </div>
  );
};

export default RestaurantPrice;
